import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { incidentIoApi, scmAuthApi, scmIntegrationsApi } from './apis';
import { signInPage } from './signIn';
import { navContent } from './nav/NavContent';
import { entityCards } from './catalog/entityCards';
import { entityContent } from './catalog/entityContent';
import { incidentIoTeamField } from './scaffolder/incidentIoField';
import { reportIssueAddon } from './techdocs/reportIssueAddon';

export const appModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    scmIntegrationsApi,
    scmAuthApi,
    incidentIoApi,
    signInPage,
    navContent,
    ...entityCards,
    ...entityContent,
    incidentIoTeamField,
    reportIssueAddon,
  ],
});
